import type { PaperStatus } from "../../../api/types";

// Maps statuses onto the mockup's four badge variants.
//   completed → completed · in_review/ready → in-review ·
//   queued → pending (not yet processed) · staged/processing → processing ·
//   failed/quota_exceeded → error (no mockup reference; uses --status-error).
const BADGE: Record<PaperStatus, { cls: string; glyph: string; label: string }> = {
  completed: { cls: "badge-completed", glyph: "●", label: "Completed" },
  in_review: { cls: "badge-in-review", glyph: "◑", label: "In Review" },
  ready: { cls: "badge-in-review", glyph: "◑", label: "In Review" },
  queued: { cls: "badge-pending", glyph: "○", label: "Pending" },
  staged: { cls: "badge-processing", glyph: "⟳", label: "Queued…" },
  processing: { cls: "badge-processing", glyph: "⟳", label: "Processing…" },
  failed: { cls: "badge-error", glyph: "✕", label: "Failed" },
  quota_exceeded: { cls: "badge-error", glyph: "✕", label: "Quota exceeded" },
};

export function StatusBadge({ status }: { status: PaperStatus }) {
  const b = BADGE[status];
  return (
    <span className={`status-badge ${b.cls}`}>
      {b.glyph} {b.label}
    </span>
  );
}
